import { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Form, Field } from 'redux-form';

import { TextField, TextArea } from 'common/components/forms';
import { contact } from 'redux/forms/actions';

import ContactFormSuccess from './ContactFormSuccess';
import { validateSubmit } from './validators';

class ContactForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      formSubmitted: false
    };
  }

  handleSubmit = (form) => {
    const { props } = this;
    const data = transformData(form);

    const successFunction = () => {
      this.setState({
        formSubmitted: true
      });
    };
    const failFunction = () => {
      this.setState({
        error: 'Unfortunately there was an error sending your contact us.'
      });
    };
    props.contact(data, successFunction, failFunction);
  };

  render() {
    const { state, props } = this;
    const { handleSubmit } = props;

    if (!state.formSubmitted) {
      return (
        <Form
          onSubmit={handleSubmit(this.handleSubmit)}
          className="c7-form"
          method="post"
        >
          <Field
            name="firstName"
            component={TextField}
            label="First Name"
            autocomplete="given-name"
            required
          />
          <Field
            name="lastName"
            component={TextField}
            label="Last Name"
            autocomplete="family-name"
            required
          />
          <Field
            name="phone"
            component={TextField}
            label="Phone"
            autocomplete="tel-national"
            required
          />
          <Field
            name="email"
            component={TextField}
            label="Email"
            autocomplete="email"
            required
          />
          <Field
            name="comments"
            component={TextArea}
            label="Comments"
            rows={4}
            required
          />
          <div className="c7-form__button-row">
            <button type="submit" className="c7-button">
              Submit
            </button>
          </div>
          {state.error && (
            <span className="c7-message--error">Error: {state.error}</span>
          )}
        </Form>
      );
    }

    return <ContactFormSuccess />;
  }
}

const transformData = (values) => {
  const data = {
    firstName: values.firstName,
    lastName: values.lastName,
    phone: values.phone,
    email: values.email,
    comments: values.comments
  };

  return data;
};

const validate = (values) => {
  const data = transformData(values);
  const errors = validateSubmit(data);
  return errors;
};

ContactForm = reduxForm({
  form: 'ContactForm',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(ContactForm);

export default connect(null, {
  contact
})(ContactForm);
